import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/conference',
    hidden: false,
    name: 'home',
    children: [
      {
        path: 'conference/:conf?',
        name: 'payment.form',
        component: () => import('@/views/form.vue'),
        meta: {
          title: 'Payment From',
          name: 'payment.form'
        }
      },
      {
        path: '/review/:orderSn',
        component: () => import('@/views/review.vue'),
        meta: {
          title: 'Order Review',
          name: 'review'
        }
      },
      {
        path: '/results/:keywords',
        component: () => import('@/views/results.vue'),
        meta: {
          title: 'Search Results',
          name: 'results'
        }
      },
      {
        path: '/success/:sn',
        component: () => import('@/views/success.vue'),
        meta: {
          title: 'Pay Results',
          name: 'success'
        }
      },
      {
        path: '/error',
        component: () => import('@/views/error.vue'),
        meta: {
          title: 'Error',
          name: 'error'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(async (to, form, next) => {
  next()
})

export default router
